import setLocalStorage from '@/utils/setLocalStorage'

const state = {
  theme: null
}
const mutations = {
  sourceTheme(state) {
    const tmp = setLocalStorage.getItem('theme')
    state.theme = tmp
  },
  changeStatus(state, playload) {
    state.theme = playload
    setLocalStorage.setItem('theme', playload)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
